import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { TooltipComponent, LegendComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { useEffect, useRef } from 'react';
import { useSize } from 'ahooks';

echarts.use([LegendComponent, TooltipComponent, CanvasRenderer, PieChart]);

interface Props {
  data: Array<any>;
}

const PieECharts: React.FC<Props> = ({ data }: Props) => {
  const chartRef = useRef<any>(null);
  const pieChart = useRef<any>(null);
  const size = useSize(document.body);

  useEffect(() => {
    const pieOption: any = {
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c}%',
      },
      color: ['#52C41A', '#FADB14', '#FA8C16', '#FF4D4F'],
      legend: {
        bottom: '5%',
        left: 'center',
        icon: 'circle',
        itemHeight: 8,
      },
      series: [
        {
          name: 'Duration',
          type: 'pie',
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 0,
            borderColor: '#fff',
            borderWidth: 6,
          },
          label: {
            formatter: '{c}%',
            position: 'inside',
            color: '#fff',
          },
          center: ['50%', '48%'],
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold',
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: 55, name: '< 5 mins' },
            { value: 25, name: '5-15 mins' },
            { value: 12, name: '15-30 mins' },
            { value: 8, name: '> 30 mins' },
          ],
        },
      ],
    };
    if (!pieChart.current) {
      pieChart.current = echarts.init(
        chartRef.current as unknown as HTMLDivElement,
        undefined,
        {
          height: 400,
        },
      );
    }
    pieChart.current?.setOption(pieOption);
  }, [data]);

  useEffect(() => {
    pieChart.current?.resize();
  }, [size]);

  return <div className="h-[400px] w-[360px]" ref={chartRef} />;
};

export default PieECharts;
